export default "__VITE_ASSET__fcd76499__"